<template>
  <el-dialog
    append-to-body
    width="500px"
    title="上传版本"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="120px"
      :model="form.data"
      :rules="form.rules"
    >
      <el-form-item label="客户端口" prop="client_type">
        <el-radio-group v-model="form.data.client_type">
          <el-radio :label="1">企业端</el-radio>
          <el-radio :label="2">个人端</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="上传安装包"
        prop="app_url"
        :rules="[
          {
            required: form.data.type == 1,
            message: '必填项',
            trigger: 'change',
          },
        ]"
      >
        <el-upload
          class="upload-demo"
          :limit="1"
          action=""
          :headers="{ token: token }"
          :file-list="fileList"
          :on-remove="removeFile"
          :multiple="false"
          :http-request="httpRequest"
        >
          <el-button icon="el-icon-upload" slot="trigger" type="primary"
            >点击上传</el-button
          >
        </el-upload>
      </el-form-item>
      <el-form-item
        label="版本日期"
        prop="version"
        :rules="[
          {
            required: form.data.type == 1,
            message: '必填项',
            trigger: 'change',
          },
        ]"
      >
        <!-- <el-date-picker
          value-format="yyyyMMdd"
          format="yyyyMMdd"
          v-model="form.data.version"
          type="date"
          placeholder="选择版本日期"
        >
        </el-date-picker> -->
        <el-input
          v-model.trim="form.data.version"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="版本号" prop="desc">
        <el-input
          v-model.trim="form.data.desc"
          placeholder="请输入"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="更新内容" prop="content">
        <el-input
          v-model="form.data.content"
          type="textarea"
          placeholder="请输入"
          :autosize="{ minRows: 2, maxRows: 4 }"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="强制更新" prop="is_forced">
        <el-radio-group v-model="form.data.is_forced">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="2">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="设备类型" prop="type">
        <el-radio-group v-model="form.data.type">
          <el-radio :label="1">安卓(android)</el-radio>
          <el-radio :label="2">IOS</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="submitForm"
          >完成</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
import * as qiniu from "qiniu-js";
import { mixinTable } from "@/mixins/table.js";
import common from "@/util";
export default {
  name: "ApproveTypeEdit",
  mixins: [mixinTable],
  data() {
    return {
      visible: false,
      isChange: false,
      loading: false,
      form: {
        loading: false,
        data: {
          app_url: "",
          version: "",
          content: "",
          is_forced: 1, // //强制更新：1-是；0-否
          type: 1, // 设备类型：安卓(android)
          client_type: "",
          desc: "",
        },
        rules: {
          client_type: [
            { required: true, message: "必填项", trigger: "change" },
          ],
          // version: [{ required: true, message: "必填项", trigger: "change" }],
          content: [{ required: true, message: "必填项", trigger: "change" }],
          is_forced: [{ required: true, message: "必填项", trigger: "change" }],
          desc: [{ required: true, message: "必填项", trigger: "change" }],
        },
      },
      fileList: [],
      token: localStorage.getItem("token"),
    };
  },
  methods: {
    getDetail(row) {
      console.log(row);
      this.form.data = {
        app_url: "",
        version: "",
        content: "",
        is_forced: 1, // //强制更新：1-是；0-否
        type: 1, // 设备类型：安卓(android)
        client_type: "",
        desc: "",
      };
      this.$nextTick(() => {
        this.$refs.elFormDom.clearValidate();
      });
      if (!!row.id) {
        this.isChange = true;
        this.fileList = [{ url: row.app_url, name: row.url }];
        common.deepClone(this.form.data, row);
      }
    },
    reset(done) {
      this.isChange = false;
      this.fileList = [];
      this.form.data.app_url = "";
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    submitForm() {
      console.log(this.form.data);
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          let apiUrl = this.isChange ? "/admin/app/edit" : "/admin/app/add";
          this.$http
            .post(apiUrl, this.form.data)
            .then((res) => {
              if (res.code === 1) {
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
    // 图片上传成功
    handleAvatarSuccess(res, file) {
      let strImg = {
        url: res.data.all_path_url,
        name: file.name,
      };
      this.fileList.push(strImg);
      this.form.data.app_url = res.data.all_path_url;
      this.$refs.elFormDom.clearValidate();
    },
    removeFile(file, fileList) {
      this.fileList = [];
      this.form.data.app_url = "";
    },
    // 图片上传之前
    beforeAvatarUpload(file) {
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.warning("上传图片大小不能超过 50MB!");
      }
      return isLt50M;
    },
    httpRequest(file) {
      let _that = this;
      _that.form.loading = true;
      console.log(qiniu, "qiniu1");
      this.$http
        .post("/common/qiniu/getUpToken", { ext: "apk" })
        .then((res) => {
          if (res.code == 1) {
            _that.uploadKey = res.data.key;
            _that.uploadToken = res.data.token;

            const qiniuUploadInfo = {
              file: file.file, //文件对象
              key: _that.uploadKey, //文件资源名称
              token: _that.uploadToken, //从后端获取的uplodaToken
            };
            console.log(qiniuUploadInfo, "002");
            const putExtra = {
              fname: "", // 文件原文件名
              params: {}, // 用来放置自定义变量
              mimeType: null, // 用来限制上传文件类型，为 null 时表示不对文件类型限制；eg: ["image/png", "image/jpeg"]
            };
            const config = {
              useCdnDomain: true, //cdn加速
              region: qiniu.region.z0, //区域
            };

            const observable = qiniu.upload(
              qiniuUploadInfo.file,
              qiniuUploadInfo.key,
              qiniuUploadInfo.token,
              putExtra,
              config
            );

            //上传开始
            observable.subscribe({
              next(res) {
                // console.log("next", res);
              },
              error(err) {
                console.log("err", err);
              },
              complete(res) {
                //来到这里就是上传成功了。。
                console.log(res, "******************");
                _that.form.data.app_url = res.key;
                _that.form.loading = false;
              },
            });
          }
        });
    },
  },
};
</script>
<style scoped lang="scss">
</style>